import React, { useState, useEffect } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation, useNavigate } from 'react-router-dom';
import Titulo from '@components/Titulo';
import Input from '@components/Input';
import Boton from '@components/Boton';
import Consultar from '@components/Consultar';
import LoadingOverlay from '@components/LoadingOverlay';

import Resumen from '@components/Resumen';
import Advertencia from '@components/Advertencia';
import { colors } from '@styles/colors';

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorStyle } from '@styles/cajaContenedor';
import { cajaContenedorPrimeroStyle } from '@styles/cajaContenedorPrimero';

import { verServApi } from "@api/wp/agenda/servicios/serviciosApi"
import { searchServiciosApi } from "@api/wp/administracion/servicios/serviciosApi";
import { useCita } from '@providers/citaContext';

function Servicio() {
  const location = useLocation();
  const navigate = useNavigate();
  const { cita, setCita } = useCita();
  const [data, setData] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [servicioSeleccionado, setServicioSeleccionado] = useState(null);
  const [servicioExpandido, setServicioExpandido] = useState(null);
  const [consultado, setConsultado] = useState(false);
  const [advertenciaBusqueda, setAdvertenciaBusqueda] = useState('');
  const ciudadId = cita?.ciudadId ?? location.state?.ciudadId;
  const ciudadNombre = cita?.ciudadNombre ?? location.state?.ciudadNombre;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Validación: si no hay sesión en localStorage o es "0", redirigir a membresía
  useEffect(() => {
    const citaVacia = !cita || (typeof cita === 'object' && Object.keys(cita).length === 0);
    if (citaVacia) {
      navigate('/home');
      return;
    }
  }, [cita, navigate]);

  const formatNumero = (value) => {
    const num = Number(value);
    if (isNaN(num)) return 'N/D';
    try {
      return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(num);
    } catch (_) {
      return num.toString();
    }
  };

  useEffect(() => {
    // Lógica de inicialización aquí
    if (ciudadId) {
      console.log('Ciudad seleccionada ID:', ciudadNombre);
    }
  }, [ciudadId]);

  const buscarServicios = async () => {
    const termino = busqueda.trim();
    if (!termino || termino.length < 3) {
      setAdvertenciaBusqueda('Escribe un término de búsqueda válido de al menos 3 caracteres.');
      setError('');
      setConsultado(false);
      setResultados([]);
      return;
    }
    setAdvertenciaBusqueda('');
    setConsultado(true);
    setCargando(true);
    setError('');
    try {
      const busquedaTrimeada = busqueda.trim();
      const request = {
        buscar: busquedaTrimeada,
        zona: ciudadNombre || 'Atlantico'
      }
      console.log('request', request)
      const response = await searchServiciosApi(request)
      console.log('Servicios encontrados:', response.result);

      // Agrupar por nombre_servicio
      const serviciosAgrupados = {};

      response.result?.forEach(servicio => {
        const nombreServicio = servicio.nombre_servicio;

        // Verificar valor de levelMem para depuración
        const levelMem = localStorage.getItem('levelMem');

        if (!serviciosAgrupados[nombreServicio]) {
          console.log('LEVEL XX ', levelMem)
          serviciosAgrupados[nombreServicio] = {
            nombre_especialidad: servicio.nombre_especialidad,
            nombre_servicio: nombreServicio,
            nombre_empresa: [],
            oid_especialidad: servicio.oid_especialidad,
            valorPreviplan: levelMem == '10' ? servicio.valorParticular : servicio.valorPreviplan,
            sku: servicio.sku,
            descrip: servicio.descrip
          };
        }
        serviciosAgrupados[nombreServicio].nombre_empresa.push({
          nombre_empresa: servicio.nombre_empresa
        });
      });
      // Convertir el objeto a array
      const resultadosAgrupados = Object.values(serviciosAgrupados);

      console.log('Servicios agrupados:', resultadosAgrupados);
      setResultados(resultadosAgrupados);
    } catch (err) {
      setError('Error al consultar los servicios ' + err.message);
      setResultados([]);
    } finally {
      setCargando(false);
    }
  };

  const continuarAUbicacion = () => {
    if (!servicioSeleccionado) {
      setError('Por favor seleccione un servicio');
      return;
    }
    setCita(prev => ({
      ...prev,
      ciudadId,
      ciudadNombre,
      especialidadNombre: servicioSeleccionado?.nombre_especialidad,
      nombreServicio: servicioSeleccionado?.nombre_servicio,
      descripcion: servicioSeleccionado?.descrip,
      empresaArray: servicioSeleccionado?.nombre_empresa,
      oidEspecialidad: servicioSeleccionado?.oid_especialidad,
      valorPreviplan: servicioSeleccionado?.valorPreviplan,
      sku: servicioSeleccionado?.sku
    }));
    navigate('/ubicacion');
  };

  return (
    <div id="cajaPrincipal"
      style={cajaPrincipalStyle}
    >
      <Titulo
        titulo="Selecciona tu servicio"
        subtitulo="Encuentra el servicio que necesitas y consulta su información y costo antes de continua."
        rutaRetorno="/home"
      ></Titulo>
      <LoadingOverlay visible={cargando} />

      {/* Div central */}
      <div style={{...cajaContenedorStyle, ...(isMobile && { marginLeft: '0', width: '100%', padding: '0 2vh', boxSizing: 'border-box' })}}>
        {/* Primer div */}

        {/* Contenido del primer div */}
        <div style={{...cajaContenedorPrimeroStyle, ...(isMobile && { width: '100%', marginLeft: '0', display: 'flex', flexDirection: 'column', alignItems: 'center' })}}>

          <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : '63vh',
            marginTop: '2vh',
            alignItems: 'center',
            alignContent: 'center',
            gap: '2vh'
          }}>
            <Input
              placeholder="Buscar servicio..."
              value={busqueda}
              onChange={(e) => {
                setBusqueda(e.target.value);
                setAdvertenciaBusqueda('');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  buscarServicios();
                }
              }}
              onIconClick={buscarServicios}
              ancho={isMobile ? '100%' : '63vh'}
              icono="buscar"
            />
            <Consultar
              label={cargando ? "Consultando..." : "Consultar"}
              onClick={buscarServicios}
              ancho={isMobile ? '100%' : '40vh'}
              alto="7vh"
              disabled={cargando}
            />

            {advertenciaBusqueda ? (
              <Advertencia
                mensaje={advertenciaBusqueda}
                ancho={isMobile ? '100%' : '63vh'}
                marginTop="1vh"
              />
            ) : null}

            {/* Mensaje de error */}
            {error && (
              <div style={{
                backgroundColor: colors.errorBg,
                border: `2px solid ${colors.error}`,
                borderRadius: '8px',
                padding: '15px',
                marginTop: '15px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                boxShadow: `0 2px 8px ${colors.errorShadow}`
              }}>
                <div style={{
                  fontSize: '24px',
                  color: colors.error,
                  fontWeight: 'bold'
                }}>
                  ⚠️
                </div>
                <div style={{
                  flex: 1,
                  color: colors.errorText,
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                    Error de conexión
                  </div>
                  <div>
                    {error}
                  </div>
                </div>
              </div>
            )}
          </div>
          {/* Lista de resultados */}
          <div id="cajaServicios" style={{
            marginTop: '3vh',
            marginLeft: '0vh',
            width: isMobile ? '100%' : '73vh',
            height: isMobile ? '40vh' : '30vh',
            overflowY: 'auto',
            padding: '1.5vh',
            boxSizing: 'border-box',
          }}>
            {resultados.length > 0 && (

              <ul style={{
                listStyle: 'none',
                padding: '1.5vh',
                margin: 0,
                width: '100%',
                boxSizing: 'border-box',
                backgroundColor: colors.gray200,
                borderRadius: '1vh',
              }}>
                {resultados.map((servicio, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      setServicioSeleccionado(servicio);
                      setServicioExpandido(servicioExpandido === servicio.nombre_servicio ? null : servicio.nombre_servicio);
                    }}
                    style={{
                      backgroundColor: servicioSeleccionado?.nombre_servicio === servicio.nombre_servicio ? colors.resumenBg : colors.white,
                      width: isMobile ? '100%' : '65vh',
                      padding: '1.5vh',
                      marginBottom: '1vh',
                      borderRadius: '1vh',
                      fontSize: isMobile ? '2.2vh' : '1.6vh',
                      fontFamily: 'Inter',
                      color: colors.primaryText,
                      cursor: 'pointer',
                      transition: 'background-color 0.2s ease',
                      boxSizing: 'border-box'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <div>{servicio.nombre_servicio}</div>
                      <div
                        style={{ display: 'flex', alignItems: 'center' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setServicioExpandido(servicioExpandido === servicio.nombre_servicio ? null : servicio.nombre_servicio);
                        }}
                      >
                        <ExpandMoreIcon style={{
                          fontSize: '2.0vh',
                          color: colors.primary,
                          transform: servicioExpandido === servicio.nombre_servicio ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.3s ease'
                        }} />
                      </div>
                    </div>

                    {servicioExpandido === servicio.nombre_servicio && (
                      <div id="cajaServicio" style={{
                        paddingTop: '1vh',
                        borderTop: '1px solid ' + colors.borderLight,
                        marginTop: '1vh',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start'
                      }}>
                        {/* Contenedor derecho: descripción arriba y valor debajo */}
                        <div id="detalleServicio" style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-end',
                          marginLeft: 'auto'
                        }}>
                          <div id="descripcionServicio"
                            style={{
                              fontSize: isMobile ? '1.8vh' : '1.5vh',
                              color: colors.primaryText,
                              backgroundColor: 'transparent',
                              borderRadius: '1vh',
                              minHeight: '4vh',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                              textAlign: 'left',
                              padding: '0 1.5vh',
                              marginRight: '0vh'
                            }}
                          >
                            {servicio.descrip || 'Sin descripción disponible'}
                          </div>

                          <div id="valorServicio"
                            style={{
                              fontWeight: 600,
                              fontSize: isMobile ? '1.8vh' : 'inherit',
                              color: colors.primaryText,
                              backgroundColor: colors.white,
                              borderRadius: '1vh',
                              height: '4vh',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              padding: '0 2vh',
                              marginTop: '1vh'
                            }}>
                            Costo del servicio: $ {formatNumero(servicio.valorPreviplan)}
                          </div>
                        </div>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            )}
            {/* Advertencia de no resultados */}
            {consultado && !cargando && !error && resultados.length === 0 && (
              <Advertencia mensaje="No se encontraron resultados para tu búsqueda." ancho="60vh" />
            )}
          </div>

          <div id="cajaSiguiente" style={{
            display: 'flex',
            flexDirection: 'column',
            width: isMobile ? '100%' : '80vh',
            marginTop: '2vh',
            gap: '2vh',
            justifyContent: isMobile ? 'center' : 'flex-end',
            alignItems: isMobile ? 'center' : 'flex-end',
            position: 'relative',
          }}>
            <Boton
              label={cargando ? "Enviando..." : "Continuar"}
              onClick={continuarAUbicacion}
              siguiente
              ancho={isMobile ? '100%' : '23vh'}
              alto="5.2vh"
              disabled={cargando || !servicioSeleccionado}
            />
          </div>
        </div>
        {/* Fin contenido del primer div */}

        {!isMobile && <Resumen ciudad={ciudadNombre} />}
      </div>

    </div>
  );
}

export default Servicio;